export const DROPDOWNS = [
  {
    open: false,
    name: 'survey',
    label: 'Survey: ',
    selectedOption: undefined,
    options: [
      {label: 'None Selected', id: 1}
    ]
  },
  {
    open: false,
    name: 'question',
    label: 'Question: ',
    selectedOption: undefined,
    options: [
      {label: 'None Selected', id: 1}
    ]
  },
  {
    open: false,
    name: 'measure',
    label: 'Measure: ',
    selectedOption: undefined,
    options: [
      {label: 'None Selected', id: 1}
    ]
  },
  {
    open: false,
    name: 'segment',
    label: 'Segment: ',
    selectedOption: undefined,
    options: [
      {label: 'None Selected', id: 1}
    ]
  },
  {
    open: false,
    name: 'decimals',
    label: 'Decimals: ',
    selectedOption: undefined,
    options: [
      {id: 0, label: '0'},
      {id: 1, label: '1'},
      {id: 2, label: '2'},
      {id: 3, label: '3'},
      {id: 4, label: '4'},
      {id: 5, label: '5'},
      {id: 6, label: '6'}
    ]
  }
];
export const INPUTS = new Map([
  ['decimals', true],
  ['measure', true],
  ['name', true],
  ['decimals', true],
  ['question', true],
  ['period', true],
  ['segment', true],
  ['survey', true]]);
